const onlyNumPattern = /[^0-9]/g;

export const makeOnlyNumber = (stringInput: string) => {
  return stringInput.replace(onlyNumPattern, "");
};

export const formatPrice = (stringInput: string, separator = ".") => {
  let temp: any = makeOnlyNumber(stringInput);
  temp = Number(temp).toLocaleString("en").replace(/\,/g, separator);
  return temp;
};
